import React from 'react';
import { ChipContent } from '../ChipContent/ChipContent';
import { ChipInput } from '../ChipInput';
import { ChipLabel } from '../ChipLabel';
/**
 * @public
 */
export function ChoiceChip({
  id,
  name,
  color = 'primary',
  disabled,
  selected,
  children,
  onClick,
  label,
  variation = 'outline',
  width = 'auto',
  value,
  ...props
}) {
  return React.createElement(ChipLabel, {
    htmlFor: id,
    width: width,
    color: color,
    ...props
  }, React.createElement(ChipInput, {
    "data-testid": id,
    name: name,
    value: value,
    type: 'radio',
    role: 'radio',
    id: id,
    disabled: disabled,
    checked: selected,
    onChange: onClick
  }), React.createElement(ChipContent, {
    label: label,
    disabled: disabled,
    selected: selected,
    variation: variation,
    color: color,
    ...props
  }, children));
}
ChoiceChip.displayName = 'Chip';